<template>
  <div class="container">
    <div class="notification is-dvodark">
      <div class="columns is-centered">
        <div class="column has-text-centered">
          <h1 class="is-size-3">
            WARRANTY APPROVAL FORM {{ $route.params.id }}
          </h1>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="required is-size-7 is-italic">
            Fields marked with a <span class="custom-dvocolor">*</span> are required
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-two-thirds">
          <div class="columns has-background-dvoalt">
            <div class="column">
              <b-field horizontal label="Primary Contact #">
                <b-input v-model="warranty.contact_number"></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns has-background-dvoalt">
            <div class="column">
              <b-field horizontal label="Company Representing">
                <p v-if=warranty.name>{{ warranty.name }}</p>
                <p v-else>Company Not Found</p>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field horizontal label="Reference Number">
                <b-input v-model="warranty.reference_number"></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column has-background-dvoalt">
              <b-field horizontal label="Serial Number">
                <p>{{ warranty.serial_id}}</p>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field horizontal label="Date Of Purchase">
                <span v-if="warranty.date_purchase" class="tag is-large is-warning">
                        {{ new Date(warranty.date_purchase).toLocaleDateString() }}
                </span>
                  <p v-else>MM/DD/YYYY</p>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field horizontal label="Add Service Code/Parts" grouped :disabled="!isAdmin">
                <b-button class="is-dvogreen" size="is-large" @click="addMisc()"> Add Parts </b-button>
                <!-- <b-button class="is-dvogreen" size="is-large" @click="addCodeParts()"> Add Service Codes and Parts </b-button> -->
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-centered has-text-centered">
        <div class="column is-half">
          <b-field horizontal label="Comment">
            <b-input type="textarea" v-model="warranty.comment" :disabled="!isAdmin"></b-input>
          </b-field>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column has-text-centered">
          <h1 class="is-size-3">
            ITEMS USED FOR REPAIR
          </h1>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-green-border">
          <div class="columns">
            <div class="column is-2">
              <p class="is-bigger">Part Number</p>
            </div>
            <div class="column is-2">
              <p class="is-bigger">Quantity</p>
            </div>
            <div class="column is-4">
              <p class="is-bigger">Description</p>
            </div>
            <div class="column is-2">
              <p class="is-bigger">Price</p>
            </div>
            <div class="column is-2">
              <p class="is-bigger">Total Price</p>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-centered" v-for="(warranty, index) in convertedWarranty" :key="index">
        <div class="column" >
          <div class="columns">
            <div class="column is-2">
              <p>{{ warranty.part_number }}</p>
            </div>
            <div class="column is-2">
              <p>{{warranty.qty}}</p>
            </div>
            <div class="column is-4">
              <p></p>
            </div>
            <div class="column is-2">
              <p>$ {{warranty.price}}</p>
            </div>
            <div class="column is-1">
              <p>$ {{rowTotalPrice(warranty.qty, warranty.price)}} </p>
            </div>
            <div class="column is-1">
              <b-button class="is-danger" @click="warrantyDeletePartModal($route.params.id, warranty.service_code, warranty.part_number, index)"><i class="far fa-trash-alt"></i></b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-centered" v-for="warranty in warrantyArray" :key="warranty.service_code">
        <div class="column" >
          <div class="columns"  v-for="(part, index) in warranty.parts" :key="part.number">
            <div class="column is-2">
              <p>{{ part.number }}</p>
            </div>
            <div class="column is-2">
              <p>{{part.quantity}}</p>
            </div>
            <div class="column is-4">
              <p>{{part.description}}</p>
            </div>
            <div class="column is-2">
              <p>{{part.distributor_cost}}</p>
            </div>
            <div class="column is-1">
              <p>$ {{rowTotalPrice(part.quantity, part.distributor_cost)}}</p>
            </div>
            <div class="column is-1">
              <b-button class="is-danger" @click="removePart(warranty.parts, index)"><i class="far fa-trash-alt"></i></b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-centered padding-custom">
        <div class="column is-half is-offset-half">
          <div class="columns has-background-dvolightgrey">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Parts Sub Total: </p>
            </div>
            <div class="column is-half has-text-right">
              <p>$ {{ computedSubTotal }}</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Landed %: </p>
            </div>
            <div class="column is-half has-text-right">
              <p v-if="warranty.instance_landing">{{warranty.instance_landing}} %</p>
              <p v-else>Something Went Wrong</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Labor Rate: </p>
            </div>
            <div class="column is-half has-text-right">
              <p v-if="warranty.instance_labor"> $ {{warranty.instance_labor}}</p>
              <p v-else>Something Went Wrong</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Oil ($): </p>
            </div>
            <div class="column is-half has-text-right">
              <b-numberinput :controls="false" v-model="warranty.oil_cost"></b-numberinput>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Freight ($): </p>
            </div>
            <div class="column is-half has-text-right">
              <b-numberinput :controls="false" v-model="warranty.freight"></b-numberinput>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half has-text-right">
              <p class="is-bigger">Total Credit: </p>
            </div>
            <div class="column is-half has-text-right">
              <p>$ {{computedTotal}}</p>
            </div>
          </div>
        </div>
      </div>
        <div class="columns is-centered mt-6">
        <div class="column has-text-centered">
            <button class="button is-medium is-dvogreen mr-2" @click="updateWarranty()" v-if="isAdmin">Save Changes</button>
            <button class="button is-medium is-danger" @click="denyWarranty" v-if="isAdmin">Deny</button>
            <button class="button is-medium is-info ml-2" @click="approveWarranty" v-if="isAdmin">Approve</button>
            <button class="button is-medium is-warning ml-2" @click="cancelWarrantyModal($route.params.id, warranty.company_id)" v-if="isAdmin">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import Auth from "@aws-amplify/auth";
import { mapState } from "vuex";
import { personHandler, companyFromPersonCompanyRoleHandler, warrantyHandler, warrantyServicePartHandler, cancellationSes } from '../graphql/mutations'
import { getParts, servicePartsFromWarranty, getWarrantyPlus } from '../graphql/queries'
import AddCodeParts from './AddCodeParts';
import AddMisc from './AddMisc'
import CancelWarrantyModal from './CancelWarrantyModal.vue';
import WarrantyDeletePartModalVue from './WarrantyDeletePartModal.vue';

export default {
  data() {
    return {
      user: null,
      user_id: null,
      userCompany: {},
      test: null,
      primaryContact: null,
      referenceNumber: null,
      serviceCode: null,
      comment: null,
      codes: [],
      items: [],
      parts: [],
      itemToBeRepaired: null,
      selectedItem: null,
      warranty: null,
      fullWarranty: null,
      warrantyArray: [],
      convertedWarranty: []
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.auth.isAdmin
    }),
    computedSubTotal: function(){
      let total = 0
      for (let i = 0, len = this.convertedWarranty.length; i < len; i++) {
          total += (this.convertedWarranty[i].qty * this.convertedWarranty[i].price) 
      }
      for (let i = 0, len = this.warrantyArray.length; i < len; i++) {
          for (let j = 0, len = this.warrantyArray[i].parts.length; j < len; j++) {
            total += (this.warrantyArray[i].parts[j].quantity * this.warrantyArray[i].parts[j].distributor_cost) 
          } 
        }
      return total.toFixed(2)
    },
    computedTotal: function(){
      let total = 0
      for (let i = 0, len = this.convertedWarranty.length; i < len; i++) {
          total += (this.convertedWarranty[i].qty * this.convertedWarranty[i].price) 
      }
      for (let i = 0, len = this.warrantyArray.length; i < len; i++) {
        for (let j = 0, len = this.warrantyArray[i].parts.length; j < len; j++) {
          total += (this.warrantyArray[i].parts[j].quantity * this.warrantyArray[i].parts[j].distributor_cost) 
        } 
      }
      if (this.warranty.instance_landing && this.warranty.instance_labor){
        return total = ( total * (1 + Number(this.warranty.instance_landing) * 0.01) + Number(this.warranty.instance_labor)  + Number(this.warranty.oil_cost) + Number(this.warranty.freight)).toFixed(2)
      }
      return (total +  Number(this.warranty.oil_cost) + Number(this.warranty.freight)).toFixed(2)
    },
  },
  methods: {
    addMisc() {
        this.$buefy.modal.open({
          parent: this,
          component: AddMisc,
          hasModalCard: true,
          trapFocus: true,
          events: {
            'pass-warranty-obj': value => {
              var normalized = value.parts.filter(function filterParts(part) {
                return part.number != null && (typeof part.quantity === 'number') && part.quantity > 0;
              });
              value.parts = normalized;
              this.warrantyArray.push(value)
            }
          }
        })
    },
    async getUserInfo() {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const userInput = {
        cognito_id: cognitoUser.attributes.sub,
        request_type: 'read_by_cognito_id'
      };
      const dvoUser = await API.graphql({
        query: personHandler,
        variables: {
          input: userInput
        }
      });
      this.user = dvoUser.data.personHandler.id
      this.user_id = dvoUser.data.personHandler.id
      const tempUserCompany = await API.graphql({
        query: companyFromPersonCompanyRoleHandler,
        variables: {
          input: {
            request_type: 'find_company_by_user',
            user_id: this.user_id
          }
        }
      });
      this.userCompany = tempUserCompany.data
      this.test = this.userCompany.companyFromPersonCompanyRoleHandler
    },
    rowTotalPrice: function(number, price) {
        return (number * price).toFixed(2)
      },
    async getWarrantyFull() {
      const Warranty = await API.graphql({
        query: servicePartsFromWarranty,
        variables: {
          input: {
            request_type: 'read_full_warranty',
            id: this.$route.params.id
          }
        }
      });
      this.fullWarranty = Warranty.data.servicePartsFromWarranty
      for(let i = 0; i < this.fullWarranty.length; i++){
        this.convertedWarranty.push({})
        this.convertedWarranty[i].warranty_id = this.fullWarranty[i].warranty_id
        this.convertedWarranty[i].service_code = this.fullWarranty[i].service_code
        this.convertedWarranty[i].part_number = this.fullWarranty[i].part_number
        this.convertedWarranty[i].price = this.fullWarranty[i].price
        this.convertedWarranty[i].qty = this.fullWarranty[i].qty
      }
    },
    async getParts() {
      const Parts = await API.graphql({
        query: getParts
      });
      this.parts = Parts.data.getParts;
    },
    async getWarranty() {
      const Warranty = await API.graphql({
        query: getWarrantyPlus,
        variables: {
          input: {
            request_type: 'read_one_with_company',
            id: this.$route.params.id
          }
        }
      });
      this.warranty = Warranty.data.getWarrantyPlus
    },
    async approveWarranty() {
      await API.graphql({
        query: warrantyHandler,
        variables: {
          input: {
            request_type: 'approve',
            id: this.$route.params.id
          }
        }
      });
      await API.graphql({
        query: cancellationSes,
        variables:{
          input:{
            warranty_id: this.$route.params.id,
            status: 'APPROVED',
            id: this.warranty.company_id
          }
        }
      })
      this.$router.push({
        name: 'WarrantyCreditRequest'
      })
    },
    async denyWarranty() {
      await API.graphql({
        query: warrantyHandler,
        variables: {
          input: {
            request_type: 'deny',
            id: this.$route.params.id
          }
        }
      });
      await API.graphql({
        query: cancellationSes,
        variables:{
          input:{
            warranty_id: this.$route.params.id,
            status: 'DENIED',
            id: this.warranty.company_id
          }
        }
      })
      this.$router.push({
        name: 'WarrantyCreditRequest'
      })
    },
    cancelWarrantyModal(warrantyId, companyId){
        this.$buefy.modal.open({
            parent: this,
            component: CancelWarrantyModal,
            hasModalCard: true,
            trapFocus: true,
            props:{
              initId: warrantyId,
              initCompany: companyId
            }
        })
    },
    addIds(){
        for (let i = 0, len = this.warrantyArray.length; i < len; i++) {
          this.warrantyArray[i].warranty_id = this.$route.params.id
        }
    },
    async updateWarranty() {
      this.warranty.total = this.computedTotal
      this.warranty.request_type = 'update'
      await API.graphql({
        query: warrantyHandler,
        variables: {
          input: {
            request_type: 'update',
            id: this.$route.params.id,
            serial_id: this.warranty.serial_id,
            company_id: this.warranty.company_id,
            reference_number: this.warranty.reference_number,
            oil_cost: this.warranty.oil_cost,
            freight: this.warranty.freight,
            comment: this.warranty.comment,
            contact_number: this.warranty.contact_number,
            total: this.computedTotal,
            instance_labor: this.warranty.instance_labor,
            instance_landing: this.warranty.instance_landing
          }
        }
      });
      this.warranty.request_type = ''
      await this.addIds();
      this.submitPivot();
      this.$router.push({
        name: 'WarrantyCreditRequest'
      })
    },
    addCodeParts() {
        this.$buefy.modal.open({
          parent: this,
          component: AddCodeParts,
          hasModalCard: true,
          trapFocus: true,
          events: {
            'pass-warranty-obj': value => {
              this.warrantyArray.push(value)
            }
          }
        })
    },
    warrantyDeletePartModal(warrantyId, serviceCode, partNumber, index){
        this.$buefy.modal.open({
        parent: this,
        component: WarrantyDeletePartModalVue,
        hasModalCard: true,
        trapFocus: true,
        props:{
              initId: warrantyId,
              initCode: serviceCode,
              initNumber: partNumber,
              initIndex: index
        },
        events: {
          'slice': value => {
            this.convertedWarranty.splice(value, 1)
          }
        }
      })
    },
    async submitPivot(){
    for (let i = 0, len = this.warrantyArray.length; i < len; i++) {
      for (let j = 0, length = this.warrantyArray[i].parts.length; j < length; j++) {
          await API.graphql({
            query: warrantyServicePartHandler,
            variables: {
              input: {
                request_type: 'add',
                service_code: this.warrantyArray[i].service_code,
                warranty_id: this.warrantyArray[i].warranty_id,
                part_number: this.warrantyArray[i].parts[j].number,
                price: this.warrantyArray[i].parts[j].distributor_cost,
                qty: Number(this.warrantyArray[i].parts[j].quantity).toFixed(2)
              }
            }
          });
      }
  }
  },
  
  },
  mounted() {
    this.getUserInfo();
    this.getParts();
    this.getWarranty();
    this.getWarrantyFull();
  }
}
</script>

<style lang="scss">
.padding-custom{
  padding-right: 5rem;
}

.is-bigger{
  font-size: 0.8em;
  font-family: 'Roboto', sans-serif;
  font-weight: 900; 
}

.field-label .label {
    color: #82bc00 !important;
    font-size: 0.8em;
    font-family: 'Roboto', sans-serif;
    font-weight: 900;
}  

.required{
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
  font-style: italic;
}

.custom-dvocolor{
  color: #82bc00;
}

.is-green-border{
  border: 1px solid #82bc00;
}

.textarea {
  background-color : transparent; 
  color: white;
}

.select{
  background-color : transparent; 
  color: white;
}

input[type="text"], textarea {
  background-color : transparent; 
  color: white;
}

h1 {
  font-family: 'Anton', sans-serif;
}

p {
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
}
</style>